import EditorPlatformMarker from './EditorPlatformMarker';

export default class EditorPlatformMarkerImage extends EditorPlatformMarker {
  constructor(scene: Phaser.Scene, x: number = 0, y: number = 0, texture?: string, frame?: number | string) {
    super(scene, x, y);
  }
}
